/**
 * Section sub-header z delikatnym podkreśleniem. labelPl = tekst nagłówka,
 * helpText = opcjonalny subtitle pod nim.
 */
export function HeaderRow({ labelPl, helpText }: { labelPl: string; helpText: string | null }) {
  const title = labelPl && labelPl !== '—' ? labelPl : null
  return (
    <div className="mt-5 mb-2 pb-1 border-b border-slate-200">
      {title && <h3 className="text-sm font-semibold text-slate-900 tracking-tight">{title}</h3>}
      {helpText && <p className="text-xs text-slate-500 mt-0.5 whitespace-pre-line">{helpText}</p>}
    </div>
  )
}
